import { gql } from '@apollo/client';

/**
 * QUERIES:
 */

// Query for retrieving team token mismatch data from the apollo cache.
export const TEAM_TOKEN_QUERY = gql`
  query GetToken {
    ClientAccountState @client {
      teamTokenMismatch @client {
        message
        actual {
          email
          token
        }
        requested {
          email
          token
        }
      }
    }
  }
`;

/**
 * MUTATIONS
 */

// Get various settings
export const SETTINGS_QUERY = gql`
  query settings {
    systemSettings {
      autoUpdateSearch
      unescapeLogLineMessage
      defaultAgeLimitHoursInOverviewPage
      defaultSearchTimeSpan
      logsPerHostInOverviewPage
      originalLogOrThreadTimeNs
      searchResultLinks {
        caseSensitive
        linkTextArg
        regex
        searchFields
        subs {
          arg
          match
          replace
        }
        url
      }
      showAllAgeLimitHoursInOverviewPage
      enableHiddenApiKeys
      stripePublishableKey
      reactPaths
      reactPathsBlacklist
      pagesExcludedForTrialEmailVerification
    }
    displaySettings {
      additionalFields
      displayMode
      showLeftNavExpanded
      sortOrder
      systemFields
      theme
      fontFamily
    }
  }
`;

export const SET_DISPLAY_SETTINGS = gql`
  mutation SetDisplaySettings($scope: Scope!, $settings: DisplaySettingsInput!) {
    setDisplaySettings(scope: $scope, settings: $settings) {
      showLeftNavExpanded
      additionalFields
      displayMode
      sortOrder
      systemFields
      theme
      fontFamily
    }
  }
`;

export const PREFERENCES_QUERY = gql`
  query getPreferences {
    preferences {
      homepages {
        team
        path
      }
      timezone
    }
  }
`;
